import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDown = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 6L8 11L13 6",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgDown);
export { ForwardRef as ReactComponent };
